import React from "react";
import {
  DECCAN_MOBILE_TAB,
  DECCAN_URL,
  PRAJAVANI_MOBILE_TAB,
  PRAJAVANI_URL,
} from "../contant";
import DeccanSuccessfulLoginPage from "./DeccanPages/DeccanSuccessfulLoginPage";
import PrajavaniSuccessfulLoginPage from "./PrajavaniPages/PrajavaniSuccessfuLoginPage";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { fetchUserData, getAppFlag } from "../utiles";

export default function SuccessFulLoginPage() {
  const callbackUrl = localStorage.getItem("callbackUrl") || "";
  const emailRequired = localStorage.getItem("emailRequired") || "";
  const userLoginDetail =
    JSON.parse(window.localStorage.getItem("user_login_detail")) || {};
  const tabDetail = localStorage.getItem("tab_detail") || "";
  const [isInputFocused, setIsInputFocused] = React.useState(false);
  const [isContinueBtnDisabled, setIsContinueBtnDisabled] =
    React.useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = React.useState({
    email: "",
    receiveMarketingAndPromitionalEmail: true,
    dhNewsLetterTopNewsOfTheDay: getAppFlag({ appUrl: DECCAN_URL })
      ? true
      : false,
  });

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    // const newValue = type === "checkbox" ? checked : value;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const updateProfileMetaDataForDeccan = async () => {
    const updatedFieldData =
      tabDetail === DECCAN_MOBILE_TAB || tabDetail === PRAJAVANI_MOBILE_TAB
        ? formData.email
        : userLoginDetail.email;
    setIsContinueBtnDisabled(true);
    try {
      const updateUserProfileResponse = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_API_BASE_URL}/auth/me/metadata`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("st-access-token")}`,
          rid: "usermetadata",
        },
        data: {
          receiveMarketingAndPromitionalEmail:
            formData.receiveMarketingAndPromitionalEmail,
          dh: {
            dhNewsLetterTopNewsOfTheDay:
              tabDetail === DECCAN_MOBILE_TAB
                ? false
                : formData?.dhNewsLetterTopNewsOfTheDay,
            newsLetter: {
              email: formData?.dhNewsLetterTopNewsOfTheDay ? updatedFieldData : null,
            },
          },
        },
      });
      if (updateUserProfileResponse.status === 200) {
        // const isEMailPresent = await fetchUserData();
        const userData = await fetchUserData();
        const isEMailPresent = userData?.userData?.emails?.length > 0
        if (
          emailRequired === "true" &&
          (tabDetail === DECCAN_MOBILE_TAB ||
            tabDetail === PRAJAVANI_MOBILE_TAB) &&
          !isEMailPresent
        ) {
          navigate("/auth/change_email");
        } else {
          window.location.assign(
            `${callbackUrl}?access_token=${localStorage.getItem(
              "access-token"
            )}&refresh_token=${localStorage.getItem("refresh-token")}`
          );
        }
      }
    } catch (error) {
      toast.error("Oops! Something went wrong.");
      setIsContinueBtnDisabled(false);
    }
  };

  const updateProfileMetaDataForPVUser = async () => {
    setIsContinueBtnDisabled(true);
    try {
      const updateUserProfileResponse = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_API_BASE_URL}/auth/me/metadata`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access-token")}`,
          rid: "usermetadata",
        },
        data: {
          receiveMarketingAndPromitionalEmail:
            formData.receiveMarketingAndPromitionalEmail,
        },
      });
      if (updateUserProfileResponse.status === 200) {
        // const isEMailPresent = await fetchUserData();
        const userData = await fetchUserData();
        const isEMailPresent = userData?.userData?.emails?.length > 0
        if (
          emailRequired === "true" &&
          (tabDetail === DECCAN_MOBILE_TAB ||
            tabDetail === PRAJAVANI_MOBILE_TAB) &&
          !isEMailPresent
        ) {
          navigate("/auth/change_email");
        } else {
          window.location.assign(
            `${callbackUrl}?access_token=${localStorage.getItem(
              "access-token"
            )}&refresh_token=${localStorage.getItem("refresh-token")}`
          );
        }
      }
    } catch (error) {
      toast.error("Oops! Something went wrong.");
      setIsContinueBtnDisabled(false);
    }
  };

  // const fetchUserData = async () => {
  //   try {
  //     const checkIsEmailPresentResponse = await axios({
  //       method: "GET",
  //       url: `${process.env.REACT_APP_API_BASE_URL}/auth/me`,
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${Cookies.get("st-access-token")}`,
  //         rid: "thirdpartypasswordless",
  //       },
  //     });
  //     if (checkIsEmailPresentResponse.status === 200) {
  //       return checkIsEmailPresentResponse?.data?.userData?.emails?.length > 0;
  //     }
  //   } catch (error) {
  //     toast.error("Oops! Something went wrong.");
  //   }
  // };

  return (
    <>
      {getAppFlag({ appUrl: PRAJAVANI_URL }) ? (
        <PrajavaniSuccessfulLoginPage
          tabDetail={tabDetail}
          formData={formData}
          handleInputChange={handleInputChange}
          updateProfileMetaDataForPVUser={updateProfileMetaDataForPVUser}
          isContinueBtnDisabled={isContinueBtnDisabled}
        />
      ) : getAppFlag({ appUrl: DECCAN_URL }) ? (
        <DeccanSuccessfulLoginPage
          tabDetail={tabDetail}
          formData={formData}
          handleInputChange={handleInputChange}
          isInputFocused={isInputFocused}
          setIsInputFocused={setIsInputFocused}
          updateProfileMetaDataForDeccan={updateProfileMetaDataForDeccan}
          isContinueBtnDisabled={isContinueBtnDisabled}
          setIsContinueBtnDisabled={setIsContinueBtnDisabled}
          callbackUrl={callbackUrl}
          navigate={navigate}
          emailRequired={emailRequired}
        />
      ) : null}
    </>
  );
}
